import { useState } from 'preact/hooks';

interface UpdateNotificationProps {
  onUpdate: () => void;
}

export function UpdateNotification({ onUpdate }: UpdateNotificationProps) {
  const [show, setShow] = useState(true);

  const handleUpdate = () => {
    onUpdate();
    setShow(false);
  };

  const handleDismiss = () => {
    setShow(false);
  };

  if (!show) {
    return null;
  }

  return (
    <div class="fixed top-4 left-4 right-4 bg-white rounded-lg shadow-lg p-4 z-50 animate-slide-down">
      <div class="flex items-start gap-3">
        <div class="flex-shrink-0">
          <svg class="w-6 h-6 text-mint-green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
        </div>
        <div class="flex-1">
          <h3 class="font-semibold text-gray-900 mb-1">Update Available</h3>
          <p class="text-sm text-gray-600 mb-3">
            A new version of BoltBuddies Art is available. Refresh to get the latest features!
          </p>
          <div class="flex gap-2">
            <button
              onClick={handleUpdate}
              class="px-4 py-2 bg-mint-green text-white rounded-lg text-sm font-medium hover:bg-green-500 transition-colors"
            >
              Refresh Now
            </button>
            <button
              onClick={handleDismiss}
              class="px-4 py-2 text-gray-600 text-sm hover:text-gray-800 transition-colors"
            >
              Later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}